import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { InspectionGradeInfo } from "../Inspection/InspectionGradeInfo";

interface AiSummaryHeaderProps {
    totalSections: number;
    onExpandAll: () => void;
    onCollapseAll: () => void;
}

export const AiSummaryHeader: React.FC<AiSummaryHeaderProps> = ({
    totalSections,
    onExpandAll,
    onCollapseAll
}) => {
    return (
        <Card className="p-3 mb-3" title="AI Summary">
            <div className="flex align-items-center justify-content-between">
                <div className="flex align-items-center gap-3">
                    <i className="pi pi-brain text-3xl text-primary"></i>
                    <div>
                        <p className="m-0 text-600">Compare original and AI-enhanced text summaries</p>
                    </div>
                </div>
                <div className="flex gap-2">
                    <Button
                        label="Expand All"
                        icon="pi pi-plus"
                        className="p-button-outlined p-button-sm"
                        onClick={onExpandAll}
                    />
                    <Button
                        label="Collapse All"
                        icon="pi pi-minus"
                        className="p-button-outlined p-button-sm"
                        onClick={onCollapseAll}
                    />
                </div>
            </div>
            <div className="mt-3">
                <InspectionGradeInfo />
            </div>
        </Card>
    );
};